import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { X, Calendar, Loader } from 'lucide-react';
import 'react-datepicker/dist/react-datepicker.css';
interface ScheduleModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSchedule: (startDate: Date, depthDays: number) => void;
}
export const ScheduleModal = ({
  isOpen,
  onClose,
  onSchedule
}: ScheduleModalProps) => {
  const [startDate, setStartDate] = useState<Date | null>(new Date()); // Set default to today
  const [depthDays, setDepthDays] = useState(3);
  const [isScheduling, setIsScheduling] = useState(false);
  useEffect(() => {
    // Reset scheduling state when modal opens
    if (isOpen) {
      setIsScheduling(false);
    }
  }, [isOpen]);
  const handleSchedule = () => {
    if (startDate) {
      setIsScheduling(true);
      // Call onSchedule immediately to start the progress outside the modal
      onSchedule(startDate, depthDays);
    }
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-745">
      <div className="bg-white rounded-lg p-6 w-[400px] relative" data-id="element-746">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600" disabled={isScheduling} data-id="element-747">
          <X size={24} data-id="element-748" />
        </button>
        <h2 className="text-xl font-semibold mb-6" data-id="element-749">Schedule Campaign</h2>
        <div className="space-y-4" data-id="element-750">
          <div data-id="element-751">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-752">
              Start Date
            </label>
            <div className="relative" data-id="element-753">
              <DatePicker selected={startDate} onChange={date => setStartDate(date)} minDate={new Date()} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#6366f1] focus:border-transparent outline-none" placeholderText="Select start date" disabled={isScheduling} data-id="element-754" />
              <Calendar className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} data-id="element-755" />
            </div>
          </div>
          <div data-id="element-756">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-757">
              Days Between Messages
            </label>
            <input type="number" min={1} max={30} value={depthDays} onChange={e => setDepthDays(parseInt(e.target.value))} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#6366f1] focus:border-transparent outline-none" disabled={isScheduling} data-id="element-758" />
          </div>
          <div className="flex gap-3 mt-6" data-id="element-759">
            <button onClick={onClose} className="flex-1 py-2 px-4 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 font-medium" disabled={isScheduling} data-id="element-760">
              Cancel
            </button>
            <button onClick={handleSchedule} className={`flex-1 bg-[#d5ff00] text-gray-900 py-2 px-4 rounded-md hover:bg-[#c0e600] font-medium flex items-center justify-center ${isScheduling ? 'opacity-70 cursor-not-allowed' : ''}`} disabled={isScheduling} data-id="element-761">
              {isScheduling ? <>
                  <Loader size={16} className="animate-spin mr-2" data-id="element-762" />
                  Processing...
                </> : 'Start Campaign'}
            </button>
          </div>
        </div>
      </div>
    </div>;
};